export const getUserData = () => ({
	type: 'GET_USER_DATA',
	axios: true,
	options: {
		url: "https://www.quikr.com/core/base/sign-in/get-user",
		method: 'get'
	}
});

export const setUserDetails = (data) => ({
	type: 'SET_USER_DATA',
	axios: false,
	data
});


// WEBPACK FOOTER //
// ../q-cars/src/redux/actions/user.js